import {Component, OnInit} from '@angular/core';
import {finalize} from 'rxjs/operators';
import { TranslationsApiService } from '../../services/translation-api.service';

@Component({
    selector: 'app-translations-admin',
    templateUrl: './translations-admin.component.html',
    styleUrls: ['./translations-admin.component.scss']
})
export class TranslationsAdminComponent implements OnInit {
    translationStatus: {
        lastUpdated: string;
        version: string;
        languages: string[];
    } | null = null;

    loading = false;
    updating = false;
    error: string | null = null;
    updateSuccess = false;
    updateMessage = '';

    constructor(private translationsApi: TranslationsApiService) {
    }

    ngOnInit(): void {
        this.loadTranslationStatus();
    }

    /**
     * Charge le statut actuel des traductions
     */
    loadTranslationStatus(): void {
        this.loading = true;
        this.error = null;

        this.translationsApi.getTranslationStatus()
            .pipe(finalize(() => this.loading = false))
            .subscribe({
                next: (status) => {
                    this.translationStatus = status;
                },
                error: (err) => {
                    this.error = 'Erreur lors du chargement du statut des traductions';
                    console.error('Erreur de chargement du statut:', err);
                }
            });
    }

    /**
     * Déclenche une mise à jour manuelle des traductions
     */
    updateTranslations(): void {
        if (this.updating) return;

        this.updating = true;
        this.updateSuccess = false;
        this.updateMessage = '';
        this.error = null;

        this.translationsApi.updateTranslations()
            .pipe(finalize(() => this.updating = false))
            .subscribe({
                next: (result) => {
                    this.updateSuccess = result.success;
                    this.updateMessage = result.message;

                    if (result.success) {
                        this.loadTranslationStatus();
                    } else {
                        this.error = result.error || 'Erreur inconnue';
                    }
                },
                error: (err) => {
                    this.updateSuccess = false;
                    this.error = 'Erreur lors de la mise à jour des traductions';
                    console.error('Erreur de mise à jour:', err);
                }
            });
    }

    /**
     * Formate une date pour l'affichage
     */
    formatDate(dateStr: string): string {
        if (!dateStr || dateStr === 'unknown' || dateStr === 'error') {
            return 'Non disponible';
        }

        try {
            const date = new Date(dateStr);
            return date.toLocaleString();
        } catch (e) {
            return dateStr;
        }
    }
}
